import React from 'react'

export default function WhiteSpace(props) {
  return <div style={{height: props.height, backgroundColor: props.color || '#fff'}} />
}
